/**
 * Generic list-page toolbar: search slot + filter slot + actions slot.
 *
 * Wraps cleanly on mobile (search spans full width; filters wrap to a
 * new row). Each slot is optional so individual pages compose only what
 * they need.
 */
import { type ReactNode } from "react";

export function Toolbar({
  search,
  filters,
  actions,
}: {
  search?: ReactNode;
  filters?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className="mb-4 flex flex-col gap-3 rounded-lg border bg-card p-3 sm:p-4">
      {(search || actions) && (
        <div className="flex flex-wrap items-center gap-2">
          {search ? <div className="min-w-0 flex-1">{search}</div> : <div className="flex-1" />}
          {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
        </div>
      )}
      {filters ? <div className="flex flex-wrap items-center gap-x-3 gap-y-2 text-xs">{filters}</div> : null}
    </div>
  );
}

export function FilterGroup({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <span className="mr-1 font-medium uppercase tracking-wider text-muted-foreground">
        {label}
      </span>
      {children}
    </div>
  );
}
